import { Config } from "./Config";
import { DesignSystem as DS } from "./DesignSystem";

export const Templates = {
    NEWSLETTERS_TEMPLATES: [
        {
            id: 0,
            design: {
                body: {
                    rows: [
                        {
                            cells: [1],
                            columns: [
                                {
                                    contents: [],
                                    values: {
                                        backgroundColor: "",
                                        border: {},
                                        padding: "0px",
                                        _meta: {
                                            htmlID: "u_column_1",
                                            htmlClassNames: "u_column",
                                        },
                                    },
                                },
                            ],
                            values: {
                                backgroundColor: "",
                                backgroundImage: {
                                    url: "",
                                    fullWidth: true,
                                    repeat: false,
                                    center: true,
                                    cover: false,
                                },
                                columns: false,
                                columnsBackgroundColor: "",
                                deletable: true,
                                displayCondition: null,
                                draggable: true,
                                duplicatable: true,
                                hideDesktop: false,
                                hideMobile: false,
                                noStackMobile: false,
                                padding: "0px",
                                selectable: true,
                                _meta: { htmlID: "u_row_1", htmlClassNames: "u_row" },
                            },
                        },
                    ],
                    values: {
                        backgroundColor: "#e7e7e7",
                        backgroundImage: {
                            url: "",
                            fullWidth: true,
                            repeat: false,
                            center: true,
                            cover: false,
                        },
                        contentAlign: "center",
                        contentWidth: "500px",
                        fontFamily: {
                            label: "Arial",
                            value: "arial,helvetica,sans-serif",
                        },
                        linkStyle: {
                            body: true,
                            linkColor: DS.colors.primary,
                            linkHoverColor: DS.colors.primary,
                            linkUnderline: true,
                            linkHoverUnderline: true,
                        },
                        preheaderText: "",
                        _meta: { htmlID: "u_body", htmlClassNames: "u_body" },
                    },
                },
                counters: { u_column: 1, u_row: 1 },
                schemaVersion: 5,
            },
        },
        {
            id: 1,
            design: {
                body: {
                    rows: [
                        {
                            cells: [1],
                            columns: [
                                {
                                    contents: [
                                        {
                                            slug: undefined,
                                            type: "image",
                                            values: {
                                                action: {
                                                    name: "web",
                                                    values: {
                                                        href: "",
                                                        target: "_blank",
                                                    },
                                                },
                                                altText: "Image",
                                                containerPadding: "0px",
                                                deletable: true,
                                                draggable: true,
                                                duplicatable: true,
                                                hideDesktop: false,
                                                hideMobile: false,
                                                selectable: true,
                                                src: {
                                                    height: 625,
                                                    url:
                                                        "https://a.mailmunch.co/user_data/landing_pages/1611167289245-unnamed (7).jpg",
                                                    width: 1601,
                                                },
                                                textAlign: "center",
                                                _meta: {
                                                    htmlClassNames: "u_content_image",
                                                    htmlID: "u_content_image_1",
                                                },
                                            },
                                        },
                                    ],
                                    values: {
                                        backgroundColor: "",
                                        border: {},
                                        padding: "0px",
                                        _meta: {
                                            htmlClassNames: "u_column",
                                            htmlID: "u_column_1",
                                        },
                                    },
                                },
                            ],
                            values: {
                                backgroundColor: "",
                                backgroundImage: {
                                    center: true,
                                    cover: false,
                                    fullWidth: true,
                                    repeat: false,
                                    url: "",
                                },
                                columns: false,
                                columnsBackgroundColor: "",
                                deletable: true,
                                displayCondition: null,
                                draggable: true,
                                duplicatable: true,
                                hideDesktop: false,
                                hideMobile: false,
                                noStackMobile: false,
                                padding: "0px",
                                selectable: true,
                                _meta: {
                                    htmlClassNames: "u_row",
                                    htmlID: "u_row_1",
                                },
                            },
                        },
                        {
                            cells: [1],
                            columns: [
                                {
                                    contents: [
                                        {
                                            slug: undefined,
                                            type: "image",
                                            values: {
                                                action: {
                                                    name: "web",
                                                    values: {
                                                        href: "",
                                                        target: "_blank",
                                                    },
                                                },
                                                altText: "Image",
                                                containerPadding: "0px",
                                                deletable: true,
                                                draggable: true,
                                                duplicatable: true,
                                                hideDesktop: false,
                                                hideMobile: false,
                                                selectable: true,
                                                src: {
                                                    height: 355,
                                                    url:
                                                        "https://a.mailmunch.co/user_data/landing_pages/1611167375804-unnamed (10).jpg",
                                                    width: 1601,
                                                },
                                                textAlign: "center",
                                                _meta: {
                                                    htmlClassNames: "u_content_image",
                                                    htmlID: "u_content_image_2",
                                                },
                                            },
                                        },
                                    ],
                                    values: {
                                        backgroundColor: "",
                                        backgroundImage: {
                                            center: true,
                                            cover: false,
                                            fullWidth: true,
                                            repeat: false,
                                            url: "",
                                        },
                                        columns: false,
                                        columnsBackgroundColor: "",
                                        deletable: true,
                                        displayCondition: null,
                                        draggable: true,
                                        duplicatable: true,
                                        hideDesktop: false,
                                        hideMobile: false,
                                        noStackMobile: false,
                                        padding: "0px",
                                        selectable: true,
                                        _meta: {
                                            htmlClassNames: "u_row",
                                            htmlID: "u_row_2",
                                        },
                                    },
                                },
                            ],
                        },
                        {
                            cells: [1],
                            columns: [
                                {
                                    contents: [
                                        {
                                            slug: undefined,
                                            type: "image",
                                            values: {
                                                action: {
                                                    name: "web",
                                                    values: {
                                                        href: "",
                                                        target: "_blank",
                                                    },
                                                },
                                                altText: "Image",
                                                containerPadding: "0px",
                                                deletable: true,
                                                draggable: true,
                                                duplicatable: true,
                                                hideDesktop: false,
                                                hideMobile: false,
                                                selectable: true,
                                                src: {
                                                    height: 352,
                                                    url:
                                                        "https://a.mailmunch.co/user_data/landing_pages/1611167409902-unnamed (8).jpg",
                                                    width: 1601,
                                                },
                                                textAlign: "center",
                                                _meta: {
                                                    htmlClassNames: "u_content_image",
                                                    htmlID: "u_content_image_3",
                                                },
                                            },
                                        },
                                    ],
                                    values: {
                                        backgroundColor: "",
                                        border: {},
                                        padding: "0px",
                                        _meta: {
                                            htmlClassNames: "u_column",
                                            htmlID: "u_column_3",
                                        },
                                    },
                                },
                            ],
                            values: {
                                backgroundColor: "",
                                backgroundImage: {
                                    center: true,
                                    cover: false,
                                    fullWidth: true,
                                    repeat: false,
                                    url: "",
                                },
                                columns: false,
                                columnsBackgroundColor: "",
                                deletable: true,
                                displayCondition: null,
                                draggable: true,
                                duplicatable: true,
                                hideDesktop: false,
                                hideMobile: false,
                                noStackMobile: false,
                                padding: "0px",
                                selectable: true,
                                _meta: {
                                    htmlClassNames: "u_row",
                                    htmlID: "u_row_3",
                                },
                            },
                        },
                        {
                            cells: [1],
                            columns: [
                                {
                                    contents: [
                                        {
                                            slug: undefined,
                                            type: "image",
                                            values: {
                                                action: {
                                                    name: "web",
                                                    values: {
                                                        href: "",
                                                        target: "_blank",
                                                    },
                                                },
                                                altText: "Image",
                                                containerPadding: "0px",
                                                deletable: true,
                                                draggable: true,
                                                duplicatable: true,
                                                hideDesktop: false,
                                                hideMobile: false,
                                                selectable: true,
                                                src: {
                                                    height: 352,
                                                    url:
                                                        "https://a.mailmunch.co/user_data/landing_pages/1611167491789-unnamed (11).jpg",
                                                    width: 1601,
                                                },
                                                textAlign: "center",
                                                _meta: {
                                                    htmlClassNames: "u_content_image",
                                                    htmlID: "u_content_image_4",
                                                },
                                            },
                                        },
                                    ],
                                    values: {
                                        backgroundColor: "",
                                        backgroundImage: {
                                            center: true,
                                            cover: false,
                                            fullWidth: true,
                                            repeat: false,
                                            url: "",
                                        },
                                        columns: false,
                                        columnsBackgroundColor: "",
                                        deletable: true,
                                        displayCondition: null,
                                        draggable: true,
                                        duplicatable: true,
                                        hideDesktop: false,
                                        hideMobile: false,
                                        noStackMobile: false,
                                        padding: "0px",
                                        selectable: true,
                                        _meta: {
                                            htmlClassNames: "u_row",
                                            htmlID: "u_row_4",
                                        },
                                    },
                                },
                            ],
                            values: {},
                        },
                        {
                            cells: [1],
                            columns: [
                                {
                                    contents: [
                                        {
                                            slug: undefined,
                                            type: "image",
                                            values: {
                                                action: {
                                                    name: "web",
                                                    values: {
                                                        href: "",
                                                        target: "_blank",
                                                    },
                                                },
                                                altText: "Image",
                                                containerPadding: "0px",
                                                deletable: true,
                                                draggable: true,
                                                duplicatable: true,
                                                hideDesktop: false,
                                                hideMobile: false,
                                                selectable: true,
                                                src: {
                                                    height: 1084,
                                                    url:
                                                        "https://a.mailmunch.co/user_data/landing_pages/1611167529656-unnamed (9).jpg",
                                                    width: 1601,
                                                },
                                                textAlign: "center",
                                                _meta: {
                                                    htmlClassNames: "u_content_image",
                                                    htmlID: "u_content_image_5",
                                                },
                                            },
                                        },
                                    ],
                                    values: {
                                        backgroundColor: "",
                                        border: {},
                                        padding: "0px",
                                        _meta: {
                                            htmlClassNames: "u_column",
                                            htmlID: "u_column_5",
                                        },
                                    },
                                },
                            ],
                            values: {
                                backgroundColor: "",
                                backgroundImage: {
                                    center: true,
                                    cover: false,
                                    fullWidth: true,
                                    repeat: false,
                                    url: "",
                                },
                                columns: false,
                                columnsBackgroundColor: "",
                                deletable: true,
                                displayCondition: null,
                                draggable: true,
                                duplicatable: true,
                                hideDesktop: false,
                                hideMobile: false,
                                noStackMobile: false,
                                padding: "0px",
                                selectable: true,
                                _meta: {
                                    htmlClassNames: "u_row",
                                    htmlID: "u_row_5",
                                },
                            },
                        },
                        {
                            cells: [1],
                            columns: [
                                {
                                    contents: [
                                        {
                                            slug: undefined,
                                            type: "image",
                                            values: {
                                                action: {
                                                    attrs: {
                                                        href: "{{href}}",
                                                        target: "{{target}}",
                                                    },
                                                    name: "web",
                                                    values: {
                                                        href: "https://bit.ly/2JwSL30",
                                                        target: "_blank",
                                                    },
                                                },
                                                altText: "Image",
                                                containerPadding: "0px",
                                                deletable: true,
                                                draggable: true,
                                                duplicatable: true,
                                                hideDesktop: false,
                                                hideMobile: false,
                                                selectable: true,
                                                src: {
                                                    height: 529,
                                                    url:
                                                        "https://a.mailmunch.co/user_data/landing_pages/1611168330188-unnamed (15).jpg",
                                                    width: 1604,
                                                },
                                                textAlign: "center",
                                                _meta: {
                                                    htmlClassNames: "u_content_image",
                                                    htmlID: "u_content_image_7",
                                                },
                                            },
                                        },
                                    ],
                                    values: {
                                        backgroundColor: "",
                                        border: {},
                                        padding: "0px",
                                        _meta: {
                                            htmlClassNames: "u_column",
                                            htmlID: "u_column_7",
                                        },
                                    },
                                },
                            ],
                            values: {
                                backgroundColor: "",
                                backgroundImage: {
                                    center: true,
                                    cover: false,
                                    fullWidth: true,
                                    repeat: false,
                                    url: "",
                                },
                                columns: false,
                                columnsBackgroundColor: "",
                                deletable: true,
                                displayCondition: null,
                                draggable: true,
                                duplicatable: true,
                                hideDesktop: false,
                                hideMobile: false,
                                noStackMobile: false,
                                padding: "0px",
                                selectable: true,
                                _meta: {
                                    htmlClassNames: "u_row",
                                    htmlID: "u_row_7",
                                },
                            },
                        },
                        {
                            cells: [1, 1, 1],
                            columns: [
                                {
                                    contents: [
                                        {
                                            slug: undefined,
                                            type: "image",
                                            values: {
                                                action: {
                                                    attrs: {
                                                        href: "{{href}}",
                                                        target: "{{target}}",
                                                    },
                                                    name: "web",
                                                    values: {
                                                        href:
                                                            "https://www.facebook.com/laobrasocialempresaria/",
                                                        target: "_blank",
                                                    },
                                                },
                                                altText: "Facebook",
                                                containerPadding: "30px 10px 20px",
                                                deletable: true,
                                                draggable: true,
                                                duplicatable: true,
                                                hideDesktop: false,
                                                hideMobile: false,
                                                selectable: true,
                                                src: {
                                                    height: 24,
                                                    url:
                                                        "https://a.mailmunch.co/user_data/landing_pages/1611168858269-866207",
                                                    width: 24,
                                                },
                                                textAlign: "right",
                                                _meta: {
                                                    htmlClassNames: "u_content_image",
                                                    htmlID: "u_content_image_8",
                                                },
                                                _override: {
                                                    mobile: {
                                                        src: {
                                                            autoWidth: false,
                                                            maxWidth: "30%",
                                                        },
                                                    },
                                                },
                                            },
                                        },
                                    ],
                                    values: {
                                        backgroundColor: "",
                                        border: {},
                                        padding: "20px 0px 0px",
                                        _meta: {
                                            htmlClassNames: "u_column",
                                            htmlID: "u_column_11",
                                        },
                                    },
                                },
                                {
                                    contents: [
                                        {
                                            slug: undefined,
                                            type: "image",
                                            values: {
                                                action: {
                                                    attrs: {
                                                        href: "{{href}}",
                                                        target: "{{target}}",
                                                    },
                                                    name: "web",
                                                    values: {
                                                        href:
                                                            "https://www.instagram.com/osdepym/",
                                                        target: "_blank",
                                                    },
                                                },
                                                altText: "Instagram",
                                                containerPadding: "30px 10px 20px",
                                                deletable: true,
                                                draggable: true,
                                                duplicatable: true,
                                                hideDesktop: false,
                                                hideMobile: false,
                                                selectable: true,
                                                src: {
                                                    height: 23,
                                                    url:
                                                        "https://a.mailmunch.co/user_data/landing_pages/1611168970566-814445",
                                                    width: 24,
                                                },
                                                textAlign: "center",
                                                _meta: {
                                                    htmlClassNames: "u_content_image",
                                                    htmlID: "u_content_image_9",
                                                },
                                                _override: {
                                                    mobile: {
                                                        src: {
                                                            autoWidth: false,
                                                            maxWidth: "30%",
                                                        },
                                                    },
                                                },
                                            },
                                        },
                                    ],
                                    values: {
                                        backgroundColor: "",
                                        border: {},
                                        padding: "20px 0px 0px",
                                        _meta: {
                                            htmlClassNames: "u_column",
                                            htmlID: "u_column_12",
                                        },
                                    },
                                },
                                {
                                    contents: [
                                        {
                                            slug: undefined,
                                            type: "image",
                                            values: {
                                                action: {
                                                    attrs: {
                                                        href: "{{href}}",
                                                        target: "{{target}}",
                                                    },
                                                    name: "web",
                                                    values: {
                                                        href:
                                                            "https://twitter.com/osdepym",
                                                        target: "_blank",
                                                    },
                                                },
                                                altText: "Twitter",
                                                containerPadding: "30px 10px 20px",
                                                deletable: true,
                                                draggable: true,
                                                duplicatable: true,
                                                hideDesktop: false,
                                                hideMobile: false,
                                                selectable: true,
                                                src: {
                                                    height: 23,
                                                    url:
                                                        "https://a.mailmunch.co/user_data/landing_pages/1611169038729-988859",
                                                    width: 24,
                                                },
                                                textAlign: "left",
                                                _meta: {
                                                    htmlClassNames: "u_content_image",
                                                    htmlID: "u_content_image_10",
                                                },
                                                _override: {
                                                    mobile: {
                                                        src: {
                                                            autoWidth: false,
                                                            maxWidth: "30%",
                                                        },
                                                    },
                                                },
                                            },
                                        },
                                    ],
                                    values: {
                                        backgroundColor: "",
                                        border: {},
                                        padding: "20px 0px 0px",
                                        _meta: {
                                            htmlID: "u_column_13",
                                            htmlClassNames: "u_column",
                                        },
                                    },
                                },
                            ],
                            values: {
                                backgroundColor: "",
                                backgroundImage: {
                                    url: "",
                                    fullWidth: true,
                                    repeat: false,
                                    center: true,
                                    cover: false,
                                },
                                columns: false,
                                columnsBackgroundColor: "#ffffff",
                                deletable: true,
                                displayCondition: null,
                                draggable: true,
                                duplicatable: true,
                                hideDesktop: false,
                                hideMobile: false,
                                noStackMobile: false,
                                padding: "0px",
                                selectable: true,
                                _meta: { htmlID: "u_row_11", htmlClassNames: "u_row" },
                                _override: {
                                    mobile: {
                                        noStackMobile: true,
                                    },
                                },
                            },
                        },
                        {
                            cells: [1],
                            columns: [
                                {
                                    contents: [
                                        {
                                            slug: undefined,
                                            type: "text",
                                            values: {
                                                color: "#0e654a",
                                                containerPadding: "10px 10px 0px",
                                                deletable: true,
                                                draggable: true,
                                                duplicatable: true,
                                                hideDesktop: false,
                                                hideMobile: false,
                                                lineHeight: "140%",
                                                linkStyle: {
                                                    inherit: true,
                                                    linkColor: "#0e654a",
                                                    linkHoverColor: "#0e654a",
                                                    linkHoverUnderline: true,
                                                    linkUnderline: true,
                                                },
                                                selectable: true,
                                                text:
                                                    '<p style="font-size: 14px; line-height: 140%;">Seguinos en nuestras redes sociales</p>',
                                                textAlign: "center",
                                                _meta: {
                                                    htmlClassNames: "u_content_text",
                                                    htmlID: "u_content_text_3",
                                                },
                                            },
                                        },
                                        {
                                            slug: undefined,
                                            type: "text",
                                            values: {
                                                color: "#000000",
                                                containerPadding: "5px 10px 10px",
                                                deletable: true,
                                                draggable: true,
                                                duplicatable: true,
                                                hideDesktop: false,
                                                hideMobile: false,
                                                lineHeight: "140%",
                                                linkStyle: {
                                                    inherit: true,
                                                    linkColor: "#0000ee",
                                                    linkHoverColor: "#0000ee",
                                                    linkHoverUnderline: true,
                                                    linkUnderline: true,
                                                },
                                                selectable: true,
                                                text:
                                                    '<p style="font-size: 14px; line-height: 140%; text-align: center;">y conoc&eacute; todo lo que hacemos para cuidarte.</p>',
                                                textAlign: "left",
                                                _meta: {
                                                    htmlID: "u_content_text_4",
                                                    htmlClassNames: "u_content_text",
                                                },
                                            },
                                        },
                                    ],
                                    values: {
                                        backgroundColor: "",
                                        border: {},
                                        padding: "0px",
                                        _meta: {
                                            htmlID: "u_column_14",
                                            htmlClassNames: "u_column",
                                        },
                                    },
                                },
                            ],
                            values: {
                                backgroundColor: "",
                                backgroundImage: {
                                    url: "",
                                    fullWidth: true,
                                    repeat: false,
                                    center: true,
                                    cover: false,
                                },
                                columns: false,
                                columnsBackgroundColor: "#ffffff",
                                deletable: true,
                                displayCondition: null,
                                draggable: true,
                                duplicatable: true,
                                hideDesktop: false,
                                hideMobile: false,
                                noStackMobile: false,
                                padding: "0px",
                                selectable: true,
                                _meta: { htmlID: "u_row_12", htmlClassNames: "u_row" },
                            },
                        },
                        {
                            cells: [1],
                            columns: [
                                {
                                    contents: [
                                        {
                                            slug: undefined,
                                            type: "button",
                                            values: {
                                                border: {},
                                                borderRadius: "25px",
                                                buttonColors: {
                                                    color: "#0e654a",
                                                    backgroundColor: "#ffcd14",
                                                    hoverColor: "#0e654a",
                                                    hoverBackgroundColor: "#ffcd14",
                                                },
                                                calculatedHeight: 46,
                                                calculatedWidth: 196,
                                                containerPadding: "10px",
                                                deletable: true,
                                                draggable: true,
                                                duplicatable: true,
                                                hideDesktop: false,
                                                hideMobile: false,
                                                href: {
                                                    attrs: {
                                                        href: "{{href}}",
                                                        target: "{{target}}",
                                                    },
                                                    name: "web",
                                                    values: {
                                                        href:
                                                            "http://www.osdepym.com.ar/PortalCMS/app.htm",
                                                        target: "_blank",
                                                    },
                                                },
                                                lineHeight: "120%",
                                                padding: "15px 30px",
                                                selectable: true,
                                                size: { autoWidth: true, width: "100%" },
                                                text:
                                                    '<span style="font-size: 14px; line-height: 16.8px;">www.osdepym.com.ar</span>',
                                                textAlign: "center",
                                                _meta: {
                                                    htmlID: "u_content_button_1",
                                                    htmlClassNames: "u_content_button",
                                                },
                                            },
                                        },
                                    ],
                                    values: {
                                        backgroundColor: "",
                                        border: {},
                                        padding: "0px 0px 30px",
                                        _meta: {
                                            htmlID: "u_column_16",
                                            htmlClassNames: "u_column",
                                        },
                                    },
                                },
                            ],
                            values: {
                                backgroundColor: "",
                                backgroundImage: {
                                    center: true,
                                    cover: false,
                                    fullWidth: true,
                                    repeat: false,
                                    url: "",
                                },
                                columns: false,
                                columnsBackgroundColor: "#ffffff",
                                deletable: true,
                                displayCondition: null,
                                draggable: true,
                                duplicatable: true,
                                hideDesktop: false,
                                hideMobile: false,
                                noStackMobile: false,
                                padding: "0px",
                                selectable: true,
                                _meta: { htmlID: "u_row_14", htmlClassNames: "u_row" },
                            },
                        },
                        {
                            cells: [1],
                            columns: [
                                {
                                    contents: [
                                        {
                                            slug: undefined,
                                            type: "image",
                                            values: {
                                                action: {
                                                    name: "web",
                                                    values: {
                                                        href: "",
                                                        target: "_blank",
                                                    },
                                                },
                                                altText: "Image",
                                                containerPadding: "0px",
                                                deletable: true,
                                                draggable: true,
                                                duplicatable: true,
                                                hideDesktop: false,
                                                hideMobile: false,
                                                selectable: true,
                                                src: {
                                                    url:
                                                        "https://a.mailmunch.co/user_data/landing_pages/1611167633781-unnamed (12).jpg",
                                                    width: 1604,
                                                    height: 269,
                                                },
                                                textAlign: "center",
                                                _meta: {
                                                    htmlID: "u_content_image_6",
                                                    htmlClassNames: "u_content_image",
                                                },
                                                _override: {
                                                    mobile: {
                                                        src: {
                                                            autoWidth: true,
                                                            maxWidth: "100%",
                                                        },
                                                    },
                                                },
                                            },
                                        },
                                    ],
                                    values: {
                                        backgroundColor: "",
                                        border: {},
                                        padding: "0px",
                                        _meta: {
                                            htmlID: "u_column_6",
                                            htmlClassNames: "u_column",
                                        },
                                    },
                                },
                            ],
                            values: {
                                backgroundColor: "",
                                backgroundImage: {
                                    url: "",
                                    fullWidth: true,
                                    repeat: false,
                                    center: true,
                                    cover: false,
                                },
                                columns: false,
                                columnsBackgroundColor: "",
                                deletable: true,
                                displayCondition: null,
                                draggable: true,
                                duplicatable: true,
                                hideDesktop: false,
                                hideMobile: false,
                                noStackMobile: false,
                                padding: "0px",
                                selectable: true,
                                _meta: { htmlID: "u_row_6", htmlClassNames: "u_row" },
                            },
                        },
                        {
                            cells: [1],
                            columns: [
                                {
                                    contents: [
                                        {
                                            slug: undefined,
                                            type: "text",
                                            values: {
                                                color: "#ffffff",
                                                containerPadding: "0px",
                                                deletable: true,
                                                draggable: true,
                                                duplicatable: true,
                                                hideDesktop: false,
                                                hideMobile: false,
                                                lineHeight: "140%",
                                                linkStyle: {
                                                    inherit: true,
                                                    linkColor: "#FFFFFF",
                                                    linkHoverColor: "#FFFFFF",
                                                    linkHoverUnderline: true,
                                                    linkUnderline: true,
                                                },
                                                selectable: true,
                                                text:
                                                    '<p style="font-size: 14px; line-height: 140%;">SUPERINTENDENCIA DE SERVICIOS DE SALUD 0800-222-72583</p>',
                                                textAlign: "center",
                                                _meta: {
                                                    htmlID: "u_content_text_1",
                                                    htmlClassNames: "u_content_text",
                                                },
                                            },
                                        },
                                        {
                                            slug: undefined,
                                            type: "text",
                                            values: {
                                                color: "#ffffff",
                                                containerPadding: "0px",
                                                deletable: true,
                                                draggable: true,
                                                duplicatable: true,
                                                hideDesktop: false,
                                                hideMobile: false,
                                                lineHeight: "140%",
                                                linkStyle: {
                                                    inherit: true,
                                                    linkColor: "#FFFFFF",
                                                    linkHoverColor: "#FFFFFF",
                                                    linkHoverUnderline: true,
                                                    linkUnderline: true,
                                                },
                                                text:
                                                    '<p style="font-size: 14px; line-height: 140%; text-align: center;"><a href="http://www.sssalud.gob.ar/" target="_blank" rel="noopener">WWW.SSSALUD.GOB.AR</a> RNOS 4-0170-4 / RNEMP 1486</p>',
                                                textAlign: "left",
                                                _meta: {
                                                    htmlID: "u_content_text_2",
                                                    htmlClassNames: "u_content_text",
                                                },
                                            },
                                        },
                                    ],
                                    values: {
                                        backgroundColor: "",
                                        border: {
                                            borderBottomColor: undefined,
                                            borderBottomStyle: "solid",
                                            borderBottomWidth: "0px",
                                            borderLeftColor: undefined,
                                            borderLeftStyle: "solid",
                                            borderLeftWidth: "0px",
                                            borderRightColor: undefined,
                                            borderRightStyle: "solid",
                                            borderRightWidth: "0px",
                                            borderTopColor: undefined,
                                            borderTopStyle: "solid",
                                            borderTopWidth: "0px",
                                        },
                                        padding: "20px 0px",
                                        _meta: {
                                            htmlID: "u_column_9",
                                            htmlClassNames: "u_column",
                                        },
                                    },
                                },
                            ],
                            values: {
                                backgroundColor: "",
                                backgroundImage: {
                                    url: "",
                                    fullWidth: true,
                                    repeat: false,
                                    center: true,
                                    cover: false,
                                },
                                columns: false,
                                columnsBackgroundColor: "#0e654a",
                                deletable: true,
                                displayCondition: null,
                                draggable: true,
                                duplicatable: true,
                                hideDesktop: false,
                                hideMobile: false,
                                noStackMobile: false,
                                padding: "0px",
                                selectable: true,
                                _meta: { htmlID: "u_row_9", htmlClassNames: "u_row" },
                            },
                        },
                    ],
                    values: {
                        backgroundColor: "#e7e7e7",
                        backgroundImage: {
                            center: true,
                            cover: false,
                            fullWidth: true,
                            repeat: false,
                            url: "",
                        },
                        contentAlign: "center",
                        contentWidth: "500px",
                        fontFamily: {
                            label: "Arial",
                            value: "arial,helvetica,sans-serif",
                        },
                        linkStyle: {
                            body: true,
                            linkColor: "#0E654A",
                            linkHoverColor: "#0E654A",
                            linkHoverUnderline: true,
                            linkUnderline: true,
                        },
                        preheaderText: "",
                        meta: {
                            htmlClassNames: "u_body",
                            htmlID: "u_body",
                        },
                    },
                },
                counters: {
                    u_column: 16,
                    u_content_button: 1,
                    u_content_image: 10,
                    u_content_text: 4,
                    u_row: 14,
                },
                schemaVersion: 5,
            },
            preview: `${Config.BASE_URL}assets/img/osdepym/email/templates/0.jpg`,
        },
    ],
};
